import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { charge } from '../actions';
import { getIsRentalShop } from '../../../auth/selectors';
import ChargeButton from '../components/ChargeButton';
import { getBarbers, getHasManyBarbers } from '../../order/selectors';
import { getCanCharge, getIsFetching, getTotal } from '../../validated/selectors';
import withCheckBarberIsClockedIn from '../../../main/timeTracker/hoc/withCheckBarberIsClockedIn';
import { CustomerIoTracker, REGISTER_TRANSACTION_STARTED } from '../../../../modules/infra/observability/customer-io';

export default compose(
  connect(state => ({
    disabled: !getCanCharge(state) || getIsFetching(state),
    forbidManyBarbers: getIsRentalShop(state) && getHasManyBarbers(state),
    totalAmount: getTotal(state),
    barberIds: getBarbers(state),
  }), { charge }),
  withHandlers({
    charge: props => () => {
      if (props.forbidManyBarbers) {
        alert('Please process payment for each barber separately!');
        return;
      }
      props.charge();
      CustomerIoTracker.getInstance().track(REGISTER_TRANSACTION_STARTED);
    },
  }),
  withCheckBarberIsClockedIn('charge', props => props.barberIds),
)(ChargeButton);
